import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ServiceService } from '../service/service.service';
import { Storage } from '@ionic/storage';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-mod0104',
  templateUrl: './mod0104.page.html',
  styleUrls: ['./mod0104.page.scss'],
})
export class Mod0104Page implements OnInit {
  pagination_reset: boolean = false;

  searchTextDisable1 = false;

  branch_name = [];
  received_branch_id = '';
  key_session = '';
  region_list = [];
  ADD_OR_UPDATE = '';
  SplitStringWord: string;
  searchText_1 = '';
  loading_1: Boolean = false;

  constructor(
    private cookies: CookieService,
    private storage: Storage,
    private api: ServiceService,
    private router: Router
  ) {
    // check session
    this.key_session = this.api.get_session_id_login();

    if (this.key_session == '' || this.key_session == 'undefined') {
      this.router.navigate(['/mod0101']);
    }

    this.SplitStringWord = this.api.SplitUrl(window.location.href);
    this.region_table();
    $('#cancel_search').hide();
  }

  ngOnInit() {
    $('#update').hide();
    this.api.setSharedData('Region');
    $('.hide-region').hide();
    $('#cancel_search').hide();
  }

  // get_all_region_list

  region_table(p_no = 0) {
    if (p_no == 0) {
      this.reset_pagination();
    }

    if (this.searchText_1 != '') {
      this.searchTable({ searchText: this.searchText_1, page_number: p_no });
    }

    var val = {
      p_no: p_no,
    };
    this.loading_1 = true;
    this.api.call_http_post({
      url: environment.API_URL + 'mastermodule/get_all_region_list_using_p_no',
      data: val,
      modname: this.SplitStringWord,
      successCb: (res) => {
        var result = res.data;
        this.region_list = result['dt'];
        this.loading_1 = false;
      },
    });
  }

  // click submit button function

  submit_region() {
    //var b_id=this.received_branch_id

    var obj = {
      region_name: $('#region_name').val(),
      region_des: $('#region_des').val(),
    };

    if (obj['region_name'] == '') {
      this.api.alert.warningAlert({
        text: 'Please Enter Region Name',
        action: 'warning',
        callback: () => {
          setTimeout(function () {
            $('#region_name').focus();
          }, 500);
        },
      });
    } else if (obj['region_des'] == '') {
      // this.api.presentAlert("Please Write any Description")
      this.api.alert.warningAlert({
        text: 'Please Write any Description',
        action: 'warning',
        callback: () => {
          setTimeout(function () {
            $('#region_des').focus();
          }, 500);
        },
      });
    } else {
      //$("#s_password").hide()
      var res = {};
      this.api.call_http_post({
        url: environment.API_URL + 'mastermodule/save_region_master',
        data: obj,
        modname: this.SplitStringWord,
        successCb: (res) => {
          var result = res.data;

          if (result['message'] == 'ok') {
            this.api.alert.warningAlert({
              text: 'Region Added Successfully',
              action: 'success',
              callback: () => {
                this.reg_reset_form();
                this.region_table();
              },
            });
          }

          if (result['message'] == 'not_ok') {
            this.api.alert.warningAlert({
              text: "Region Can't be Added, Please Check Existing Regions",
              action: 'error',
            });
          }
        },
      });
    }
  }

  // edit region status

  edit_region(region_id) {
    $('.hide-region').show();
    $('#submit').hide();
    $('#update').show();

    this.ADD_OR_UPDATE = 'Update Region';
    //scroll event
    this.api.scroll_event('#region_name');

    var val = {
      region_id: region_id,
    };

    this.api.call_http_post({
      url:
        environment.API_URL + 'mastermodule/get_a_region_val_using_region_id',
      data: val,
      modname: this.SplitStringWord,
      successCb: (res) => {
        var result = res.data;

        $('#reg_id').val(result.dt[0].region_id);
        $('#region_name').val(result.dt[0].region_name);
        $('#region_des').val(result.dt[0].region_des);
      },
    });
  }

  // update function

  update_region() {
    var obj = {
      region_id: $('#reg_id').val(),
      region_name: $('#region_name').val(),
      region_des: $('#region_des').val(),
    };

    if (obj['region_name'] == '') {
      this.api.alert.warningAlert({
        text: 'Please Enter Region Name',
        action: 'warning',
        callback: () => {
          setTimeout(function () {
            $('#region_name').focus();
          }, 500);
        },
      });
      return;
    } else if (obj['region_des'] == '') {
      this.api.alert.warningAlert({
        text: 'Please Write any Description',
        action: 'warning',
        callback: () => {
          setTimeout(function () {
            $('#region_des').focus();
          }, 500);
        },
      });
      return;
    } else {
      var res: any;
      this.api.call_http_post({
        url: environment.API_URL + 'mastermodule/update_region_master',
        data: obj,
        modname: this.SplitStringWord,
        successCb: (res) => {
          var result = res.data;
          if (result['message'] == 'ok') {
            this.api.alert.warningAlert({
              text: 'Region Updated Successfully',
              action: 'update',
              callback: () => {
                this.reg_reset_form();
                this.region_table();
              },
            });
          }

          if (result['message'] == 'not_ok') {
            this.api.alert.warningAlert({
              text: 'Region Can’t be Updated, Please Check Existing Regions',
              action: 'error',
            });
          }
        },
      });
    }
  }

  // region reset form

  reg_reset_form() {
    $('#region_name').val('');
    $('#region_des').val('');
    $('#submit').show();
    $('#update').hide();
    this.ADD_OR_UPDATE = '';
    $('.hide-region').hide();
  }

  reset_region() {
    $('#region_name').val('');
    $('#region_des').val('');
  }

  showRegion() {
    $('.hide-region').show();

    this.reset_region();

    this.ADD_OR_UPDATE = 'Add Region';

    $('#submit').show();
    $('#update').hide();
  }

  delete_region_master(region_id) {
    var obj = {
      region_id: region_id,
    };
    this.api.call_http_post({
      url: environment.API_URL + 'mastermodule/delete_region_master',
      data: obj,
      modname: this.SplitStringWord,
      successCb: (res) => {
        var result = res.data;

        if (result['message'] == 'ok') {
          this.api.alert.warningAlert({
            text: 'Region Deleted Successfully',
            action: 'delete',
            callback: () => {
              this.reg_reset_form();
              this.region_table();
            },
          });
        }

        if (result['message'] == 'not_ok') {
          this.api.alert.warningAlert({
            text: 'Region Can’t be Deleted, There is a Dependant Record',
            action: 'error',
          });
        }
      },
    });
  }

  searchTable(event) {
    this.searchText_1 = event['searchText'];
    var obj = {
      searchText: this.searchText_1,
      p_no: event['page_number'],
    };

    this.loading_1 = true;
    this.api.call_http_post({
      url: environment.API_URL + 'mastermodule/search_region_master',
      data: obj,
      modname: this.SplitStringWord,
      successCb: (res) => {
        var result = res.data;
        if (result['message'] == 'ok') {
          this.region_list = result['data'];
          this.loading_1 = false;
        }
      },
    });
  }

  clearsearch(event) {
    this.searchText_1 = '';

    var obj = {
      searchText: '',
      page_number: 0,
    };
    this.searchTable(obj);
    this.reset_pagination();
  }

  // for pagination
  pag_change(event) {
    if (this.searchText_1 != '') {
      var search_obj = {
        searchText: this.searchText_1,
        page_number: event,
      };
      this.searchTable(search_obj);
    } else {
      this.region_table(event);
    }
  }

  reset_pagination() {
    this.pagination_reset = true;
    setTimeout(() => {
      this.pagination_reset = false;
    }, 1000);
  }
}
